import { render, staticRenderFns } from "./FGMCreateFolderGroup.vue?vue&type=template&id=5412e691&scoped=true"
import script from "./FGMCreateFolderGroup.vue?vue&type=script&lang=js"
export * from "./FGMCreateFolderGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412e691",
  null
  
)

export default component.exports